import { selectMapCulturesWithCheckboxValues } from 'app/containers/Map/slice/selectors';

import { FC, Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useMapSlice } from '../../../../slice';
import MapMenu, { MapMenuRow } from 'app/components/MapMenu/MapMenu';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import * as S from './SelectFieldsByCultureMenu.styles';

interface IProps {}

const SelectFieldsByCultureMenu: FC<IProps> = () => {
  const { t } = useTranslation();

  const { actions } = useMapSlice();
  const dispatch = useDispatch();

  const mapCulturesWithCheckboxes = useSelector(
    selectMapCulturesWithCheckboxValues,
  );

  const [activeDropdownCulturesIds, setActiveDropdownCulturesIds] = useState<
    number[]
  >([]);

  const onCultureFieldsSelect = (cultureId: number, checked: boolean) => {
    if (checked) {
      dispatch(actions.removeSelectedFieldsByCultureId(cultureId));
    } else {
      dispatch(actions.addSelectedFieldsByCultureId(cultureId));
    }
  };

  const onVariationClick = (variationId: number, checked: boolean) => {
    if (checked) {
      dispatch(actions.removeSelectedFieldsByVariationId(variationId));
    } else {
      dispatch(actions.addSelectedFieldsByVariationId(variationId));
    }
  };

  const onDropdownIconClick = (cultureId: number) => {
    setActiveDropdownCulturesIds(prevState => {
      if (prevState.includes(cultureId)) {
        return prevState.filter(id => cultureId !== id);
      } else {
        return [...prevState, cultureId];
      }
    });
  };

  return (
    <MapMenu>
      {mapCulturesWithCheckboxes.map(culture => (
        <Fragment key={culture.cultureName}>
          <MapMenuRow>
            <S.Part>
              <S.CultureDropdownIcon
                $disabled={!culture.cultureVariations.length}
                $active={Boolean(
                  culture.cultureVariations.length &&
                    activeDropdownCulturesIds.includes(culture.cultureId),
                )}
                onClick={() => onDropdownIconClick(culture.cultureId)}
              />

              <Checkbox
                onChange={() =>
                  onCultureFieldsSelect(culture.cultureId, culture.checked)
                }
                key={culture.cultureName}
                checked={culture.checked}
                indeterminate={culture.indeterminate}
              >
                {culture.cultureName ||
                  t('Common.WithoutCulture', 'Without culture')}
              </Checkbox>
            </S.Part>
          </MapMenuRow>
          <S.VariationsContainer
            $active={Boolean(
              culture.cultureVariations.length &&
                activeDropdownCulturesIds.includes(culture.cultureId),
            )}
          >
            {culture.cultureVariations.map(variation => (
              <MapMenuRow
                key={variation.cultureVariation.id}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  onVariationClick(
                    variation.cultureVariation.id,
                    variation.checked,
                  );
                }}
              >
                <S.Part style={{ marginLeft: 45 }}>
                  <Checkbox
                    checked={variation.checked}
                    indeterminate={variation.indeterminate}
                  >
                    {variation.cultureVariation.name}
                  </Checkbox>
                </S.Part>
              </MapMenuRow>
            ))}
          </S.VariationsContainer>
        </Fragment>
      ))}
    </MapMenu>
  );
};

export default SelectFieldsByCultureMenu;
